import {
  EMPLOYEE_SALARY_FETCHING,
EMPLOYEE_SALARY_SUCCESS,
EMPLOYEE_SALARY_FAILED
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEE_SALARY_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case EMPLOYEE_SALARY_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case EMPLOYEE_SALARY_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
